import { t } from 'i18next';
import React, { CSSProperties, FC, ReactNode, useEffect, useState } from 'react';
import CurrencyInput, { CurrencyInputProps } from 'react-currency-input-field';
import styled from 'styled-components';
import { useAuth } from '~/routes/components/AuthProvider';
interface CustomInputProps {
  label?: string | ReactNode
  limit?: number
  prefix?: string
  value?: string | number
  onChange?: (value: string | number) => void
  suffix?: string,
  error?: boolean
  id?: string
  disableOpacity?: boolean
  allowDecimals?: boolean
  withLabels?: boolean
  min?: number
  styleLabel?: CSSProperties
  inputWidth?: CSSProperties['width']
}

//TO DO
// refactor this component
// clean it
export const CustomInput: FC<CustomInputProps & CurrencyInputProps> = (props) => {
  const { systemData } = useAuth()
  const { id, limit, prefix, onChange, styleLabel, label, min, error, ...inputProps } = props

  const [errorInput, setErrorInput] = useState(false);
  const [value, setValue] = useState<string | number>('');
  const [className, setClassName] = useState('');
  const [values, setValues] = useState();
  const [rawValue, setRawValue] = useState<string | undefined>(' ');
  const [suffix, setSuffix] = useState(props.suffix || '')

  useEffect(() => {
    setErrorInput(error)
  }, [error])

  /**
   * Handle validation
   */
  const handleOnValueChange: CurrencyInputProps['onValueChange'] = (value, _, values): void => {
    props.onChange(value)
    //@ts-ignore
    setValues(values);
    setRawValue(value === undefined ? 'undefined' : value || ' ');

    if (!value) {
      setClassName('');
      setValue('');
      return;
    }
    if (props.limit && Number(value.replace(',', '.')) > limit) {
      setClassName('error');
      setValue(value);
      return;
    } else if (!!value && min && Number(value.replace(',', '.')) < Number(Number(min).toFixed(2))) {
      setClassName('error');
      setValue(value);
      return;
    }

    setClassName('');
    setValue(value);
  };

  const isSwissDairy = systemData?.chEnv === 1

  return (
    <StyledInputWrapper
      $maxWidth={props?.style?.maxWidth}
      $disableOpacity={props.disableOpacity}
      $withLabels={props.withLabels}
      $inputWidth={props?.inputWidth}
    >
      <div id={props.id} className={`ui input ${errorInput ? 'error' : className}`}>
        {props.label && <label style={{ ...styleLabel }}>{props.label}</label>}
        <CurrencyInput
          className={`form-control ${errorInput ? 'error' : className}`}
          value={value}
          onValueChange={handleOnValueChange}
          intlConfig={{ locale: isSwissDairy ? 'de-CH' : 'de-DE' }}
          onFocus={() => {
            setSuffix('')
          }}
          placeholder={t('Please enter a number')}
          onBlur={() => setSuffix(props.suffix)}
          step={1}
          allowDecimals={Boolean(props.allowDecimals)}
          decimalScale={props.allowDecimals ? props.decimalScale || 2 : 0}
          disabled={props.disabled}
          decimalsLimit={props.allowDecimals ? props.decimalScale || 2 : 0}
          {...inputProps}
          suffix={suffix}
        />
      </div>
    </StyledInputWrapper>
  );
};

export default CustomInput;

const StyledInputWrapper = styled.div<{
  $disableOpacity?: boolean,
  $withLabels?: boolean,
  $maxWidth?: CSSProperties['maxWidth'],
  $inputWidth: CSSProperties['width']
}>`
width: ${props => props?.$maxWidth ?? '100%'};
 div {
   width: 100%;
   ${props => props.$withLabels && `
   display: flex;
   flex-direction: column;
   align-items: baseline;
   label{
    font-weight 700;
    color: #5e6672;
    background: white;
    width: 100%;
    text-align: left;
   }
   `}
 }
 .error {
  background: #fff6f6 !important;
  border-color: #e0b4b4 !important;
  color: #9f3a38 !important;
 }
 input[disabled] {
  opacity: ${props => props.$disableOpacity ? '1' : '0.7'} !important;
 }
 
 input {    
  ${props => props.$inputWidth ? `width: ${props.$inputWidth} !important;` : ''}
 }
`